// removed by extract-text-webpack-plugin
module.exports = {"loaderWrapper":"_3yJqoh1cmJaKuq0zZeX3Am","spinner":"_2GndBGDC4LfACbhVCn9QLG","rotate":"_1H5w4DH5HNeXuWYRr5ol_k","dot1":"_2kD0KQ2be563CPIUQdHw-s","dot2":"_1GKgoMB9o9wVsdZdw2mHs4","bounce":"_1OBIJM_ew_ySPJAOGyQ4ol"};


//////////////////
// WEBPACK FOOTER
// ./components/loader.scss
// module id = 1171
// module chunks = 0